const i="wix-draft-plugin-emoji",e={insert:`${i}.insert`};export{i as EMOJI_TYPE,e as emojiModals};
//# sourceMappingURL=types.js.map
